import "./design/App.css";
import Pro from "./tiers/Pro";
import Studio from "./tiers/Studio";
import Basic from "./tiers/Basic";
import Success from "./tiers/Success";
import Foundersclub from "./tiers/foundersclub";
import Test from "./tiers/test";
import CheckoutForm from "./tiers/CheckoutForm";
import Navbar from "./navbar/Navbarstart";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ResetPasswordForm from "./reset_password/resetPasswordForm";
import SuccessPage from "./reset_password/success";
import ValidateUrl from "./reset_password/validateUrl";
import InputUserCredentials from "./reset_password/inputUserCredentials";
import ExistingUserCheckout from "./existing_user/existingUserCheckout";
import Login from "./existing_user/login";
import { DataManagerProvider } from "./backend/DataManager";
import FoundersclubHidden from "./tiers/foundersclubHidden";

function App() {
  return (
    <main>
       <Navbar></Navbar>
      <DataManagerProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/pro" element={<Pro/>} />
          <Route path="/studio" element={<Studio/>} />
          <Route path="/foundersclub" element={<Foundersclub/>} />
          <Route path="/basic" element={<Basic/>} />
          <Route path="/resetYourPassword" element={<InputUserCredentials/>} />
          <Route path="/resetPassword/:inputKey" element={<ValidateUrl/>} />
          <Route path="/resetPasswordForm/:inputKey" element={<ResetPasswordForm/>} />
          <Route path="/resetPasswordSuccess" element={<SuccessPage/>} />
          <Route path="/existingUser/checkout" element={<ExistingUserCheckout/>} />
          <Route path="/existingUser/login" element={<Login/>} />
          
          <Route path="/rwNLB2PnBEXgPU3fFVrW5VOUIm5X1F6HtSBPowezfNo" element={<FoundersclubHidden/>} />
        </Routes>
      </BrowserRouter>
      </DataManagerProvider>
    </main>
  );
}

export default App;
